export default [
  {
    university: "Drexel University",
    date: "September 2011 to June 2016",
    degree: "Bachelor's of Science in Computer Science",
    description: `I graduated from Drexel University in 2016 with a degree in computer science with a concentration
      in <b>Human Computer Interaction</b> and <b>Artificial Intelligence</b>. While there, I took many
      classes, some interesting, some not, explored Philadelphia, made a great group of friends, and was
      president of the school's chapter of <b>Engineers Without Borders</b>. Our project was to build
      water filtration devices in the small village of Miramar in El Salvador. As president, I was in
      charge of meetings, managing the various teams we had, and talking with the university and advisors.`,
    links: [{ href: "https://drexel.edu", label: "Drexel University" }],
  },
  {
    university: "Technical University of Denmark",
    date: "August 2014 to December 2014",
    degree: "Study Abroad",
    description: `I had the amazing opportunity to study abroad in Denmark for a semester and it was incredible. While
      I did take courses in web services, data mining, and statistics, I benefited much more from my experiences meeting
      new people, trying new things, and exploring as many places as I possibly could. My first day, as I was bringing
      my bags into a converted shipping container, I was greeted by my 7 other roommates from all different countries
      and some of their families who were visiting for the weekend. We ate, we drank, we learned a traditional Greek dance.
      It was an overwhelmingly warm welcome and continued to be wonderful throughout.<br /><br />
      I planned my schedule to where I had class all day Monday and finished by noon on Tuesday so I could have a 5
      day weekend. My first week there I met some people who said they were going to a city in Norway I had never heard
      of the following week and wanted to know if I wanted to join. I booked my flight the next day and had an amazing
      time. During the next few months there I would meet many new friends, drink plenty of beer, eat amazing food, and
      traveled to 10 other countries.`,
    links: [{ href: "https://www.dtu.dk/english", label: "Technical University of Denmark"}],
  },
]